import React from 'react'
import VisualAcuity from './refractionContactLens/visualAcuity'
import Refraction from './refractionContactLens/refraction'
import ContactLens from './refractionContactLens/contactLens'

export default function RefractionContactLensForm(props) {
  return (
    <div className="refraction-contact-lens-form">
      <VisualAcuity {...props} />
      <Refraction {...props} />
      <ContactLens {...props} />
    </div>
  )
}